import { render, staticRenderFns } from "./arrows.vue?vue&type=template&id=cf5a9a90"
import script from "./arrows.vue?vue&type=script&lang=js"
export * from "./arrows.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports